import ReactDOM from "react-dom";
import App from "./components/App";
import { initI18n } from "./utils/i18nUtils";
// import "./index.css";

let container = document.getElementById("supabanner-container");

if (!container) {
  container = document.createElement("div");
  container.id = "supabanner-container";
  document.body.appendChild(container);
}

initI18n().then(() => {
  ReactDOM.render(<App />, document.getElementById("supabanner-container"));
});
